import { createSlice } from "@reduxjs/toolkit";
import { FetchingTypes } from "../interfaces/types";

export interface initialStateDashboardProps {
    fetchingStockData: FetchingTypes;
    stockData?: any;
    fetchingLeadsFunnel: FetchingTypes;
    fetchingLeadsTable: FetchingTypes;
    leadsFunnel?: any;
    leadsTable?: any;
}

const initialState: initialStateDashboardProps = {
    fetchingStockData: "unknown",
    fetchingLeadsFunnel:"unknown",
    fetchingLeadsTable: "unknown",
    leadsFunnel:undefined,
    leadsTable:undefined,
    stockData: undefined
}

const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {
        getStockDataRequest: (state) => {
            state.fetchingStockData = "loading";
        },
        getStockDataSuccess: (state, action) => {
            state.fetchingStockData = "success";
            state.stockData = action.payload;
        },
        getStockDataFailure: (state) => {
            state.fetchingStockData = "failure";
        },
        getLeadsFunnelRequest: (state) => {
            state.fetchingLeadsFunnel = "loading";
        },
        getLeadsFunnelSuccess: (state, action) => {
            state.fetchingLeadsFunnel = "success";
            state.leadsFunnel = action.payload;
        },
        getLeadsFunnelFailure: (state) => {
            state.fetchingLeadsFunnel = "failure";
        },
        getLeadsTableRequest: (state) => {
            state.fetchingLeadsTable = "loading";
        },
        getLeadsTableSuccess: (state, action) => {
            state.fetchingLeadsTable = "success";
            state.leadsTable = action.payload;
        },
        getLeadsTableFailure: (state) => {
            state.fetchingLeadsTable = "failure";
        }
    }
});

export const { getStockDataRequest, getStockDataSuccess, getStockDataFailure, getLeadsFunnelRequest, getLeadsFunnelSuccess, getLeadsFunnelFailure, getLeadsTableRequest, getLeadsTableSuccess, getLeadsTableFailure } = dashboardSlice.actions;

export default dashboardSlice.reducer;